module.exports = __webpack_public_path__ + "img/checkin.2d46f58f.svg";